<template>
    <div class="flex flex-direction">
        <header-modular></header-modular>
        <img class="banner " src="../../assets/img/help/img.png"/>
        <img class="banner " src="../../assets/img/help/img_1.png"/>
        <img class="banner " src="../../assets/img/help/img_2.png"/>
        <img class="banner " src="../../assets/img/help/img_3.png"/>
        <img class="banner " src="../../assets/img/help/img_4.png"/>
        <img class="banner " src="../../assets/img/help/img_5.png"/>
        <img class="banner " src="../../assets/img/help/img_6.png"/>
        <footer-modular></footer-modular>
    </div>
</template>

<script>

import HeaderModular from "@/views/web/components/HeaderModular";
import FooterModular from "@/views/web/components/FooterModular";

export default {
    name: "index",
    components: {FooterModular,HeaderModular},
    data() {
        return {

        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {

    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.header-container {
    width: 100%;
    height: 100px;
    background-color: #0a2240;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 1200px;
        height: 100px;
        margin: 0 auto;

        .logo {
            height: 55px;
        }

        .headRightTel {
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 30px;
            letter-spacing: 1px;
            color: #f5f5f5;

            img {
                width: 20px;
                height: 20px;
                margin-right: 10px;
            }
        }

        .login-btn {
            cursor: pointer;
            width: 99px;
            height: 40px;
            background-color: #ff9600;
            border-radius: 20px;
            font-size: 16px;
            line-height: 40px;
            color: #ffffff;
            text-align: center;
        }

        .to-emof {
            width: 150px;
            height: 41px;
            padding: 3px;
            cursor: pointer;
            background-image: linear-gradient(
                    37deg, #ffb400, #fc7802), linear-gradient(#ff9600, #ff9600);
            background-blend-mode: normal, normal;
            border-radius: 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-left: 10px;

            .title {
                font-size: 14px;
                font-weight: 700;
                line-height: 17px;
                color: #fff;
                text-align: center;
            }

            .tips {
                font-size: 12px;
                line-height: 18px;
                text-align: center;
                color: #021e3f;
            }
        }
    }
}

.banner {
    width: 100%;
}
.content-info{
    width: 1200px;
    align-self: center;
    padding: 30px 0;
    .advantage-item{
        width: 577px;
        height: 274px;
        border-radius: 20px;
        background-color: #f0f4fc;
        padding: 40px 40px;
        margin-top: 30px;
        cursor: pointer;
        position: relative;
        &:after{
            width: 33px;
            height: 33px;
            background-color: #d8deec;
            border-top-left-radius: 20px;
            border-bottom-right-radius: 100px;
            position: absolute;
            top: 0;
            left: 0;
            content: '';
        }
        &.active{
            background-image: linear-gradient(-37deg,
                #0a2240 0%,
                #0e3668 100%),
            linear-gradient(
                    #f0f4fc,
                    #f0f4fc);
            background-blend-mode: normal,
            normal;
            &:after{
                background-color: #2d84f2;
            }
            .title{
                color: #ff9600;
                &:before{
                    background-color: #2d84f2;
                }
            }
            .content{
                color: #ffffff;
            }
        }
        .title{
            font-size: 26px;
            font-weight: bold;
            color: #333333;
            position: relative;
            &:before{
                position: absolute;
                content: '';
                width: 38px;
                height: 3px;
                background-color: #ff9600;
                left: 0;
                bottom: -20px;
            }
        }
        .content{
            font-size: 22px;
            line-height: 34px;
            color: #666666;
            margin-top: 60px;
        }
    }
}
.shenqin-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    span {
        display: block;
        width: 100px;
        line-height: 40px;
        text-align: right;
    }

    input {
        flex: 1;
        display: block;
        height: 40px;
        padding: 0 10px;
        border: 1px solid #e2e2e2;
        margin-right: 20px;
    }
}

.dialog-footer {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 400px;
    margin: 0 auto;

    .set-btn {
        width: 120px;
    }
}
</style>